module.exports = __webpack_public_path__ + "img/ruanbao1.e7072894.jpg";